/**
 * The section illustrations the Climb Plan PDF draws, as PNG.
 *
 * WHY PNG AND NOT THE .svg THE SCREEN USES. @react-pdf draws PNG and JPEG and
 * nothing else, and its own `<Svg>` primitive supports a narrow subset that
 * does not include the `clip-path`, `<defs>` and inline `style` these Figma
 * exports are built from. They are rasterised once, by hand, and committed -
 * not converted at runtime, because a conversion that can fail is one more way
 * for a download button to do nothing.
 *
 * They are also deliberately NOT data: `sanitizeImageSrc` rejects a relative
 * Vite asset URL by design, so a section icon would never survive the trip
 * through `ClimbPlanPDFData`. These are presentation, and they are imported
 * straight into the document the way the logo already is.
 *
 * Sources, for whoever regenerates them:
 *   assets/images/planner/top-hat-96.svg
 *   assets/images/planner/climb-plan/*.svg
 *   assets/icons/clusters/blocks.svg
 *   api.iconify.design/solar/{map-point,medal-ribbon}-bold.svg, tinted #637381
 *   assets/icons/program-detail/spotlight.svg (the Program Spotlight's own
 *   illustration, as the screen draws it), rasterised in Chromium at 2x
 */
import topHat from "@/assets/images/planner/climb-plan/pdf/top-hat.png";
import highSchoolPriorities from "@/assets/images/planner/climb-plan/pdf/high-school-priorities.png";
import keysToSuccess from "@/assets/images/planner/climb-plan/pdf/keys-to-success.png";
import ctsos from "@/assets/images/planner/climb-plan/pdf/ctsos.png";
import afterHighSchool from "@/assets/images/planner/climb-plan/pdf/after-high-school.png";
import skillsToBuild from "@/assets/images/planner/climb-plan/pdf/skills-to-build.png";
import blocks from "@/assets/images/planner/climb-plan/pdf/blocks.png";
import spotlight from "@/assets/images/planner/climb-plan/pdf/spotlight.png";
import schoolPin from "@/assets/images/planner/climb-plan/pdf/school-pin.png";
import credentialMedal from "@/assets/images/planner/climb-plan/pdf/credential-medal.png";

export const CLIMB_PLAN_PDF_ICONS = {
  topHat,
  highSchoolPriorities,
  keysToSuccess,
  ctsos,
  afterHighSchool,
  skillsToBuild,
  /** The three-blocks mark, on each Building Block card. */
  blocks,
  spotlight,
  /** The two panel headings inside High School Priorities. */
  schoolPin,
  credentialMedal,
} as const;
